export const getIsLoading = (state) => state.recommendedProperty?.isLoading;
